import { useContext } from 'react';
import { MachinesContext } from './MachinesContext';

export const useMachinesContext = () => {
  const context = useContext(MachinesContext);
  if (!context) {
    throw new Error('MachinesContext was not found');
  }

  return context;
};
